import styled, { css, keyframes } from 'styled-components'

const showContent = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Wrapper = styled.div`
  padding: 0;
  /* background-color: tomato; */

  .content-section {
    /* background-color: blue; */
    transition: all ease-in-out 400ms;
    animation: ${showContent} 400ms;
  }

  .title-tooltip {
    h3 {
      position: relative;
      display: inline-block;
    }
  }

  .cards {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }
`

export const SectionTitle = styled.h3`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 16px;

  &.large {
    font-size: 18px;
    font-weight: 500;
  }
`

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.media.desktop}) {
      max-width: calc(50% - 16px);
      /* min-width: 400px; */
      width: 100%;

      &:nth-child(odd) {
        max-width: 50%;
        margin-right: 16px;
      }
    }

    @media (max-width: ${theme.media.ipad}) {
      max-width: calc(50% - 8px);
      min-width: 300px;
      width: 100%;

      &:nth-child(odd) {
        margin-right: 16px;
      }
    }

    @media (max-width: 680px) {
      max-width: 100%;
      width: 100%;

      &:nth-child(odd) {
        max-width: 100%;
        margin-right: 0px;
      }
    }

    .col-6 {
      width: 100% !important;
      margin-left: 10px;

      &:first-child {
      }

      &:nth-child(2) {
      }
    }
  `}
`
